import { Grid, Typography } from "@mui/material";
import styles from './toast.module.scss';
import React, { useState, useRef, useEffect } from 'react';
import toast from "react-hot-toast";

interface ToastErrorProps {
    defaultMessage?: string;
    message?: string;
}
const ToastError: React.FC<ToastErrorProps> = ({ defaultMessage = 'Error Occured', message }) => {
    const [isOpen, setIsOpen] = useState(true);
    const errortoastclose = useRef<HTMLDivElement>(null);
    const handleClose = () => {
        toast.remove();
    };
    useEffect(() => {
        function handleClickOutside(event: any) {
            if (errortoastclose.current && !errortoastclose.current.contains(event.target)) {
                toast.remove();
            }
        }
        window.addEventListener('click', handleClickOutside);
    }, []);
    return (
        <>
            {(
                <div className={styles.totalErrorLayout} ref={errortoastclose}>
                    <Grid className={styles.container}>

                        <div style={{ marginRight: "16px" }} onClick={handleClose} >
                            <img src='/images/errorIcon.svg' style={{ width: "30px", height: "20px", cursor: "pointer" }} />
                        </div>

                        <div style={{ display: "inline-block" }}>
                            <Typography className={styles.Error}>{message || defaultMessage}</Typography>
                            <Typography className={styles.tryagain}>Sorry, please try again later.</Typography>
                        </div>
                    </Grid >
                </div >
            )}
        </>
    )
}
export default ToastError;